import React from 'react';

import { Alert, Badge } from 'antd';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.span`
    font-size: ${(props) => (props.$small ? '1.1rem' : '1.25rem')};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    color: ${(props) => props.theme.TextColor};

    @media only screen and (max-width: 720px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .legend-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.9rem;
        justify-content: flex-start;

        &.green {
            color: ${(props) => props.theme.SuccessColor};
        }

        .ant-badge {
            padding: 0 0.15rem;
            .ant-badge-status-dot {
                width: ${(props) => (props.$small ? '.6rem' : '.75rem')};
                height: ${(props) => (props.$small ? '.6rem' : '.75rem')};
            }
        }
    }
`;

const TransactionsStatusLegend = () => {
    const Statuses = ['Billable', 'Job', 'Option'];

    const ColorMap = {
        Option: StyleVariables.WarningColor,
        Job: StyleVariables.DangerColor,
        Billable: StyleVariables.SuccessColor,
    };
    const TextMap = {
        Option: 'Option',
        Job: 'Confirmed',
        Billable: 'To Bill',
    };

    return (
        <Alert
            message="Transaction Status Description"
            description={
                <Wrapper>
                    <div className="legend-item green">
                        <NwIcon icon={byPrefixAndName.fass['check']} />
                        <span>Paid</span>
                    </div>
                    <div className="legend-item">
                        <NwIcon icon={byPrefixAndName.fasl['file-invoice']} />
                        <span>Invoiced</span>
                    </div>
                    <div className="legend-item">
                        <NwIcon icon={byPrefixAndName.fasl['lock']} />
                        <span>Invoice Draft</span>
                    </div>
                    {Statuses.map((status) => (
                        <div key={status} className="legend-item">
                            <Badge color={ColorMap[status]} />
                            <span>{TextMap[status]}</span>
                        </div>
                    ))}
                </Wrapper>
            }
            type="info"
            showIcon
        />
    );
};

export default TransactionsStatusLegend;
